module.exports = __webpack_public_path__ + "img/mostly-at-home.4e255c4f.png";